<template>
  <button v-if="href == null" :type="type" class="btn btn-after btn-animated" data-slot="default">
    <slot>sample title</slot>
  </button>
  <m-a v-else :href="href" :target="target">
    <button :type="type" class="btn btn-after btn-animated" data-slot="default">
      <slot>sample title</slot>
    </button>
  </m-a>
</template>

<script>
import {ButtonProps} from "./ButtonProps";
import mA from '../Tags/A'

export default {
  name: "Button9",
  components: {mA},
  props: {
    ...ButtonProps
  }
};
</script>

<style scoped>


.btn {
  position: relative;
  display: inline-block;
  outline: none;
  border: none;
  cursor: pointer;
  background-color: var(--secondary);
  font-size: 20px;
  font-weight: 500;
  border-radius: 10px;
  box-shadow: 0 6px var(--secondary);
  transition: all 0.2s;
}

.btn:hover {
  transform: translateY(3px);
  box-shadow: 0 4px var(--primary);
}

.btn:active {
  transform: translateY(6px);
  box-shadow: none;
}

.btn:active::after {
  transform: scaleX(1.4) scaleY(1.6);
  opacity: 0;
}

.btn-after {
  background-color: var(--primary);
}

.btn-after::after {
  background-color: var(--primary);
}

.btn::after {
  content: "";
  position: absolute;
  display: inline-block;
  height: 100%;
  width: 100%;
  border-radius: 10px;
  top: 0;
  left: 0;
  z-index: -1;
  transition: all 0.4s;
}

</style>